import React, { useRef, useEffect, useCallback, useImperativeHandle, forwardRef } from 'react'

/**
 * Textarea that auto-resizes to fit its content.
 * Drop-in replacement for <textarea> — passes all props through.
 * Supports forwardRef so callers can access the underlying DOM element.
 */
const AutoResizeTextarea = forwardRef(({ onChange, className = '', ...props }, externalRef) => {
  const internalRef = useRef(null)

  useImperativeHandle(externalRef, () => internalRef.current)

  const resize = useCallback(() => {
    const el = internalRef.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
  }, [])

  // Resize on mount and when value changes programmatically
  useEffect(() => { resize() }, [props.value, resize])

  const handleChange = (e) => {
    onChange?.(e)
    resize()
  }

  return (
    <textarea
      ref={internalRef}
      onChange={handleChange}
      className={`overflow-hidden ${className}`}
      {...props}
    />
  )
})

export default AutoResizeTextarea
